import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DefaultEditor } from '@app/shared/smart-table/ng2-smart-table';

@Component({
  standalone: false,
  selector: 'app-datetimepicker',
  templateUrl: './datetimepicker.component.html',
  styleUrls: ['./datetimepicker.component.scss']
})
export class DatetimepickerComponent extends DefaultEditor implements OnInit {
  @ViewChild('datetimeModal', { static: false }) datetimeModal: TemplateRef<any>;
  public dialogRef?: MatDialogRef<any>;

  public contadorHoras = 0;
  public contadorMinutos = 0;
  public contadorSegundos = 0;
  public selectedDate: Date | null = null;

  constructor(private dialog: MatDialog) {
    super();
  }

  ngOnInit() {}

  public sumarHoras() {
    if (this.contadorHoras === 23 && this.contadorMinutos === 59) {
      this.contadorHoras = 0;
    } else {
      this.contadorHoras += 1;
    }
  }

  public restarHoras() {
    if (this.contadorHoras === 0) {
      this.contadorHoras = 23;
      this.contadorMinutos = 59;
    } else {
      this.contadorHoras -= 1;
    }
  }

  public sumarMinutos() {
    if (this.contadorMinutos === 59) {
      if (this.contadorHoras === 23) {
        this.contadorHoras = 0;
        this.contadorMinutos = 0;
      } else {
        this.contadorMinutos = 0;
        this.contadorHoras = this.contadorHoras + 1;
      }
    } else {
      this.contadorMinutos += 1;
    }
  }

  public restarMinutos() {
    if (this.contadorMinutos === 0) {
      this.contadorMinutos = 59;
      if (this.contadorHoras === 0) {
        this.contadorHoras = 0;
      } else {
        this.contadorHoras = this.contadorHoras - 1;
      }
    } else {
      this.contadorMinutos -= 1;
    }
  }

  public sumarSegundos() {
    if (this.contadorSegundos === 59) {
      this.contadorSegundos = 0;
      this.contadorMinutos = this.contadorMinutos + 1;
    } else {
      this.contadorSegundos += 1;
    }
  }

  public restarSegundos() {
    if (this.contadorSegundos === 0) {
      this.contadorSegundos = 59;
      if (this.contadorMinutos === 0) {
        this.contadorMinutos = 0;
      } else {
        this.contadorMinutos = this.contadorMinutos - 1;
      }
    } else {
      this.contadorSegundos -= 1;
    }
  }

  public openModal() {
    this.dialogRef = this.dialog.open(this.datetimeModal, {
      width: '700px',
      maxWidth: '90vw',
      disableClose: true,
      autoFocus: false
    });
  }

  public guardarDatos() {
    if (!this.selectedDate) {
      this.dialogRef?.close();
      return;
    }

    const localDate = new Date(
      this.selectedDate.getFullYear(),
      this.selectedDate.getMonth(),
      this.selectedDate.getDate(),
      this.contadorHoras,
      this.contadorMinutos,
      this.contadorSegundos
    );

    // Aquí iría el envío al servidor con localDate.toISOString(), etc.
    this.dialogRef?.close();
  }
}
